import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';

/**
 * Whether or not the mailbox calendar supports modifications, e.g. creating, updating, or deleting things.
 * If this is disabled, the mailbox should be treated as read-only.
 *
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const mailboxCalendarModificationCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        // If the mailbox supports modifications, they're always allowed
        return true;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return (
            !mailboxInfo /* if mailboxInfo is not present, allow by default */ ||
            !isLocalDataBackedMailboxInfo(
                mailboxInfo
            ) /* do not allow for local data backed mailboxes (e.g. PST files) */
        );
    },
};
